export function HandleFormatMoney(amount: number): string {
  try {
    return amount.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    });
  } catch (e) {
    return amount.toString();
  }
}
